import styled from '@emotion/styled';
import { COLORS } from "../../constants/Theme";
import { ComponentZindex } from "../../constants/zindex";
export const ToasterStyled = styled.div `
	--toastify-color-light: #fff;
	--toastify-color-dark: #121212;
	--toastify-text-color-success: ${COLORS.content.primary};
	--toastify-text-color-error: ${COLORS.content.primary};
	--toastify-text-color-warning: ${COLORS.content.primary};
	--toastify-text-color-info: ${COLORS.content.primary};
	--toastify-color-info: ${COLORS.background.brandLight};
	--toastify-color-success: ${COLORS.background.positive.light};
	--toastify-color-error: ${COLORS.background.negative.light};
	--toastify-color-warning: ${COLORS.background.warning.light};
	--toastify-text-color-light: ${COLORS.content.primary};
	--toastify-toast-width: fit-content;
	--toastify-toast-min-height: ${(props) => props.height || (props.isSubTextIncluded ? '70px' : '56px')};
	--toastify-toast-max-height: ${(props) => props.height || 'fit-content'};
	font-family: inherit;
	z-index: ${(props) => props.zIndex || ComponentZindex.TOASTER};

	.custom-position {
		position: relative;
	}
	.Toastify__toast-container {
		padding: 0;
	}

	.Toastify__toast--success {
		border: 1px solid ${COLORS.stroke.positive.lightAlt};
	}

	.Toastify__toast--info {
		border: 1px solid ${COLORS.stroke.brandLightAlt};
	}

	.Toastify__toast--default {
		border: 1px solid ${COLORS.stroke.primary};
	}

	.Toastify__toast--error {
		border: 1px solid ${COLORS.stroke.negative.lightAlt};
	}

	.Toastify__toast--warning {
		border: 1px solid ${COLORS.stroke.warning.lightAlt};
	}

	.Toastify__toast {
		padding: ${(props) => (props.isSubTextIncluded ? '16px' : '12px')};
		max-width: ${(props) => props.width};
		border-radius: 8px;
	}

	.Toastify__progress-bar {
		height: 4px;
	}

	.Toastify__close-button {
		display: block;
		margin: auto;
	}

	.Toastify__toast-icon {
		align-self: center;
		margin-inline-end: 12px;
		height: ${(props) => (props.isSubTextIncluded ? '38px' : '20px')};
	}

	.Toastify__toast-body {
		padding: 0;
	}

	.Toastify__progress-bar-theme--colored.Toastify__progress-bar--default {
		background: ${COLORS.content.brand};
	}

	.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info {
		background: ${COLORS.content.brand};
	}

	.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {
		background: ${COLORS.content.warning};
	}

	.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success {
		background: ${COLORS.content.positive};
	}

	.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
		background: ${COLORS.content.negative};
	}

	.Toastify__toast-body > div:last-child {
		display: flex;
	}

	.Toastify__slide-enter {
		animation: slideIn 1s ease forwards,
			bounce cubic-bezier(0.68, -0.55, 0.27, 1.55) 0.5s both;
	}
	.Toastify__slide-exit {
		animation: slideOut 0.5s ease-in-out forwards;
	}

	@keyframes bounce {
		0%,
		20%,
		50%,
		80%,
		100% {
			transform: translateY(0); /* Start and end at the original position */
		}
		40% {
			transform: translateX(-20px); /* Bouncing up */
		}
		60% {
			transform: translateX(20px); /* Small bounce before settling */
		}
	}
	@keyframes slideIn {
		0% {
			transform: translateX(-100%); /* Start off-screen to the left */
			opacity: 0;
		}
		100% {
			transform: translateX(0); /* End at the original position */
			opacity: 1;
		}
	}
	@keyframes slideOut {
		0% {
			transform: translateX(0); /* Start from the original position */
			opacity: 1;
		}
		100% {
			transform: translateX(100%); /* Slide out to the right */
			opacity: 0;
		}
	}
`;
//# sourceMappingURL=Toaster.styled.js.map